
import { useLocation } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

const Header = () => {
  const location = useLocation();
  const isResultsPage = location.pathname.includes('relatorio');

  return (
    <header className="border-b border-gray-200 py-3 sm:py-4 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 sm:gap-0">
        <div className="flex items-center gap-2 sm:gap-4">
          <a href="https://www.conversion.com.br" target="_blank" rel="noopener noreferrer">
            <img 
              src="https://www.conversion.com.br/wp-content/uploads/2022/11/logo-conversion.svg" 
              alt="Conversion Logo" 
              className="h-6 sm:h-8"
            />
          </a>
          <span className="text-gray-700 text-lg sm:text-[24px] font-light">|</span>
          <div className="flex items-baseline">
            <Link to="/" className="text-gray-700 text-lg sm:text-[24px] hover:text-gray-900">Page Score</Link>
            <Badge variant="secondary" className="ml-2 text-[10px] font-medium translate-y-[-2px]">
              Beta
            </Badge>
          </div>
        </div>
        <div className="hidden sm:flex justify-end">
          {isResultsPage ? (
            <Link to="/">
              <Button variant="outline" className="flex items-center gap-2 text-sm">
                <ArrowLeft className="w-4 h-4" />
                Nova análise
              </Button>
            </Link>
          ) : (
            <a 
              href="https://www.conversion.com.br/blog/o-que-e-seo" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Button variant="outline" className="flex items-center gap-2 text-sm">
                Guia de SEO
                <ArrowUpRight className="w-4 h-4" />
              </Button>
            </a>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
